window.addEventListener('DOMContentLoaded', function () {
  var thumbsEl = document.querySelector('.mySwiper');
  var mainEl = document.querySelector('.mySwiper2');

  if (!thumbsEl || !mainEl || !window.Swiper) return;

  var thumbs = new Swiper(thumbsEl, {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true
  });

  new Swiper(mainEl, {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    thumbs: {
      swiper: thumbs
    }
  });
});